import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './Notification.css';
import { TNotificationType } from './types';

export interface INotificationsProps {
  onClose?(): void;
  onCloseEnd?(): void;
  text: string;
  type: TNotificationType;
  visible: boolean;
}

export function Notification({ onClose, onCloseEnd, text, type, visible }: INotificationsProps) {
  return (
    <div
      className={clsx(styles['container'], styles[`container--${type}`], !visible && styles['container--hidden'])}
      onClick={onClose}
      onTransitionEnd={onCloseEnd}
    >
      <p className={styles['text']}>{text}</p>
    </div>
  );
}
